import { HEADER_E2E_AUTH } from "@faire/web--source/common/consts/HEADER_E2E_AUTH";
import { EnvironmentFactory } from "@faire/web--source/common/EnvironmentStore";
import { headerInterceptorFactory } from "./headerInterceptor";
var Env = EnvironmentFactory();
export var e2eAuthHeaderInterceptor = headerInterceptorFactory({
    header: HEADER_E2E_AUTH,
    value: function() {
        return Env.get().getOrDefault("E2E_AUTH", undefined);
    }
});
